import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=74dc8f92&scoped=true&lang=pug"
import script from "./DataSource.vue?vue&type=script&lang=js"
export * from "./DataSource.vue?vue&type=script&lang=js"
import style0 from "./DataSource.vue?vue&type=style&index=0&id=74dc8f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc8f92",
  null
  
)

export default component.exports